import Hostname from './Hostname';
import getPersonaTerms from '../helpers/personaTerms';

/**
 * Returns the host-specific naming for personas.
 * FIXtool users see 'Medewerker(s)', all other hosts see 'Deelnemer(s)'.
 *
 * @returns {import('../helpers/personaTerms').PersonaTerms}
 */
const usePersonaTerms = () => getPersonaTerms(Hostname().Name);

export default usePersonaTerms;
